import { useState } from "react";
import tabletrans from "../../translate/tables";
import MessagesTableRow from "./MessagesTableRow";

function MessagesTable(props) {
  const content = props.content;
  const lang = props.lang;
  const [detail, showDetail] = useState(-1);
  return (
    <table>
      <thead>
        <tr>
          <th>
            <p>نام</p>
            <i></i>
          </th>
          <th style={{ textAlign: "center" }}>
            <p>شماره</p>
            <i></i>
          </th>
          <th>
            <p>پیام</p>
            <i></i>
          </th>
          <th>
            <p>تاریخ</p>
            <i></i>
          </th>
          <th>
            <p>وضعیت</p>
            <i></i>
          </th>

          <th></th>
        </tr>
      </thead>
      <tbody>
        {content && content
          ? content.map((slider, i) => (
              <MessagesTableRow
                detail={detail}
                showDetail={showDetail}
                item={slider}
                index={i}
                key={i}
                lang={lang}
              />
            ))
          : ""}
      </tbody>
    </table>
  );
}
export default MessagesTable;
